{
  "standby": {
    "instruction": "ACERCA TU CÁMARA",
    "qrLabel": "Código QR para marcar asistencia",
    "siteTerminal": "{site} · {terminal}",
    "brand": "FERMIN"
  },
  "connecting": {
    "title": "Conectando…",
    "description": "Estamos conectando el marcador con Fermin."
  },
  "offline": {
    "title": "Sin conexión",
    "description": "Estamos intentando reconectar…",
    "headline": "FERMIN · Sin conexión · Estamos intentando reconectar…",
    "duplicateTitle": "Hay otra pantalla con este marcador",
    "duplicateDescription": "Ciérrala; esta pantalla se reconecta sola.",
    "duplicateBlockedDescription": "Cierra la otra pantalla y toca aquí para reconectar.",
    "duplicateBlockedAction": "Reconectar"
  },
  "challenge": {
    "instruction": "Mantén la cámara apuntando…",
    "qrLabel": "Código QR de la marcación en curso",
    "progressLabel": "Comprobando tu presencia"
  },
  "confirmation": {
    "name": "✓ {name}",
    "checkIn": "Entrada",
    "checkOut": "Salida",
    "checkLabel": "Marcación registrada"
  },
  "queue": {
    "waiting": "Un momento… hay otra marcación en curso"
  },
  "autonomous": {
    "badge": "Modo sin conexión",
    "qrLabel": "Código QR de modo sin conexión",
    "description": "Marca con tu teléfono con datos; la marcación se confirma al volver la conexión."
  },
  "paused": {
    "title": "Marcador en pausa",
    "description": "Contacta a tu empresa",
    "headline": "FERMIN · Marcador en pausa · Contacta a tu empresa",
    "reason": "El servicio está suspendido. Contacta a tu empresa."
  },
  "disabled": {
    "title": "Marcador deshabilitado",
    "description": "Contacta a tu empresa",
    "reasonAdmin": "Tu administrador deshabilitó este marcador.",
    "reasonSiteInactive": "La sede de este marcador está inactiva.",
    "configureOther": {
      "action": "Configurar otro marcador",
      "title": "¿Configurar otro marcador?",
      "description": "Este teléfono dejará de estar vinculado a {terminal}. Para usarlo con otro marcador necesitarás un código de activación nuevo.",
      "thisTerminal": "este marcador",
      "cancel": "Cancelar",
      "confirm": "Configurar otro marcador"
    }
  },
  "replaced": {
    "title": "Este marcador fue vinculado en otra pantalla",
    "description": "Solo una pantalla puede estar activa por marcador. Si esta debe seguir operando, pide un código nuevo.",
    "action": "Configurar de nuevo"
  },
  "reconfigure": {
    "action": "Configurar de nuevo"
  },
  "status": {
    "connecting": "Conectando…",
    "online": "Conectado",
    "offline": "Sin conexión",
    "autonomous": "Modo sin conexión",
    "paused": "Marcador en pausa",
    "disabled": "Marcador deshabilitado",
    "lastSignal": "Última señal hace {seconds} s"
  },
  "clock": {
    "label": "Hora de la sede",
    "unsynced": "Hora sin sincronizar"
  }
}
